import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";
import { StatusChip, PaceFlag } from "@/components/Badges";
import { Link } from "react-router-dom";
import { MerchScorecard } from "./MerchScorecard";

export default function MyPOs() {
  const { t } = useLang();
  const [pos, setPos] = useState([]);
  useEffect(() => { api.get("/pos").then((r) => setPos(r.data)); }, []);
  return (
    <div>
      <div className="eyebrow">{t("nav_my_pos")}</div>
      <h1 className="text-2xl font-bold" style={{ color: "var(--brand-navy)" }}>My POs</h1>
      <div className="mt-4"><MerchScorecard /></div>
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-3 mt-4">
        {pos.map((p) => (
          <Link key={p.id} to={`/po/${p.id}`} data-testid={`my-po-${p.po_number}`} className="hag-surface p-4">
            <div className="flex items-center justify-between gap-2">
              <span className="font-bold" style={{ color: "var(--brand-navy)" }}>{p.po_number}</span>
              <PaceFlag flag={p.pace_flag} />
            </div>
            <div className="text-sm">{p.weaver_name}</div>
            <div className="mt-2"><StatusChip status={p.status} /></div>
            <div className="text-xs text-[#7C8E9E] mt-2">
              ETA: {p.eta ? new Date(p.eta).toLocaleDateString() : "—"} · {p.line_item_count} lines · {p.percent_complete}%
            </div>
          </Link>
        ))}
        {pos.length === 0 && <div className="text-sm text-[#7C8E9E]">No POs yet.</div>}
      </div>
    </div>
  );
}
